import { isNullOrUndefined } from '@utils/predicates';
import { TYPEOF } from '@constants';

export function parseNumericValue(value: unknown): number {
	if (isNullOrUndefined(value) || value === '') {
		return NaN;
	}
	let raw: unknown = value;
	if (typeof value === TYPEOF.STRING) {
		raw = (value as string).replace(/,/g, '');
	}
	return Number(raw);
}
